import type { ThemeConfig } from 'antd';

export const THEME_TOKEN: ThemeConfig['token'] = {
  fontFamily: 'var(--font-primary)',
  colorBgLayout: 'var(--color-gray-1)',
  colorText: 'var(--color-gray-9)',
  colorPrimary: '#7a45e6',
};

export const THEME_COMPONENTS: ThemeConfig['components'] = {
  Layout: {
    headerBg: 'var(--color-gray-9)',
    headerColor: 'var(--color-gray-1)',
    siderBg: 'var(--color-gray-2)',
  },
  Modal: {
    colorBgMask: 'rgba(38, 38, 38, .8)',
  },
  Button: {
    borderRadius: 8,
    fontSizeLG: 14,
    colorLink: 'var(--color-primary)',
    colorLinkHover: 'var(--color-violet-5)',
    colorLinkActive: 'var(--color-primary)',
  },
  Table: {
    cellPaddingBlock: 12,
  },
  Tooltip: {
    fontSize: 12,
    lineHeight: 1.66666667,
    borderRadius: 8,
  },
  Input: {
    fontSizeLG: 14,
  },
  Form: {
    itemMarginBottom: 16,
  },
  Alert: {
    fontSize: 12,
    lineHeight: 1.66666667,
    defaultPadding: '8px 16px',
    withDescriptionPadding: '8px 16px',
    withDescriptionIconSize: 14,
    colorInfoBg: 'var(--color-gray-3)',
  },
  Spin: {
    dotSizeLG: 56,
  },
  Divider: {
    orientationMargin: 0,
  },
};

export const THEME_CONFIG: ThemeConfig = {
  token: THEME_TOKEN,
  components: THEME_COMPONENTS,
};
